import React from 'react';
import { Star } from 'lucide-react';
import { DayActivity } from '../../utils/activityHelpers';
interface WeeklyActivityDotsProps {
  weeklyActivity: DayActivity[];
  color?: 'emerald' | 'indigo' | 'slate';
  weeklyGoal?: number;
}
export function WeeklyActivityDots({
  weeklyActivity,
  color = 'emerald',
  weeklyGoal
}: WeeklyActivityDotsProps) {
  const colorClasses = {
    emerald: 'bg-emerald-500 border-emerald-600 text-white',
    indigo: 'bg-indigo-500 border-indigo-600 text-white',
    slate: 'bg-slate-700 border-slate-800 text-white'
  };
  // Calculate how many days have been practiced
  const practicedDaysCount = weeklyActivity.filter(day => day.practiced).length;
  const goalReached = weeklyGoal ? practicedDaysCount >= weeklyGoal : false;
  return <div className="flex flex-col gap-2 w-full" data-id="element-2535">
      <div className="flex justify-between w-full relative" data-id="element-2536">
        {/* Goal line indicator */}
        {weeklyGoal && <div className="absolute top-4 left-0 h-0.5 bg-slate-200 -z-10" style={{
        width: '100%'
      }} data-id="element-2537" />}

        {weeklyActivity.map((day, index) => {
        // If we have a weekly goal, highlight the dot that represents the goal
        const isGoalDot = weeklyGoal && index === weeklyGoal - 1;
        return <div key={day.label} className="flex flex-col items-center gap-1.5 relative" data-id="element-2538">
              {isGoalDot && <div className="absolute -top-5 text-[10px] font-bold text-amber-500 whitespace-nowrap" data-id="element-2539">
                  Doel
                </div>}
              <div className={`w-8 h-8 rounded-full flex items-center justify-center border-2 ${day.practiced ? colorClasses[color] : 'bg-white border-slate-200 text-slate-400'} ${isGoalDot && !goalReached ? 'ring-2 ring-amber-400 ring-offset-1' : ''}`} data-id="element-2540">
                {day.practiced && <Star className="w-4 h-4 fill-current" data-id="element-2541" />}
              </div>
              <span className={`text-[10px] font-bold uppercase ${day.isToday ? 'text-slate-800' : 'text-slate-500'}`} data-id="element-2542">
                {day.label}
              </span>
            </div>;
      })}
      </div>
    </div>;
}